// src/pages/Documentos/EditarDocumento.js
import React from "react";
import { useParams } from 'react-router-dom';
import CadastrarEdital from "./CadastrarEdital";

const EditarEdital = () => {
    const { id } = useParams();

    return <CadastrarEdital editalId={id} />;
};

export default EditarEdital;
